import React from "react";
import { Button, Row } from "antd";

import PageContainer from "../layout/PageContainer";
import styles from "./CompanyInfo.module.css";
import IconCurveArrow from "../assets/images/iconCurveArrow.png";
import LayoutFooter from "../components/LayoutFooter";

const WithDrawalInfo = () => {
    const info = [
        {
            title: "통합회원 탈퇴 방법",
            info: (
                <div style={{ border: "1px solid #C4CAD3", paddingRight: "30px" }}>
                    <ol>
                        <li>RUTA40 디지털키 메인 화면의 우측 상단에서 설정 버튼을 터치합니다.</li>
                        <li>설정 화면 우측 하단의 탈퇴하기 버튼을 터치합니다.</li>
                        <li>탈퇴 확인 팝업의 확인 버튼을 터치합니다.</li>
                        <li>통합 회원 탈퇴 화면의 내용을 확인하신 후, 안내사항 확인 동의를 체크합니다.</li>
                        <li>계정 비밀번호를 입력하신후, 탈퇴 버튼을 터치합니다.</li>
                    </ol>
                </div>
            ),
        },
        {
            title: "계정 및 관련 데이터 삭제 방침",
            info: (
                <Button
                    block
                    style={{
                        height: 44,
                        border: "1px solid black",
                    }}
                    onClick={() => window.open("https://ruta40.co.kr/privacypolicy", "_blank", "noopener, noreferrer")}
                >
                    자세히 보기
                    <img src={IconCurveArrow} width={16} style={{ marginLeft: "5px", verticalAlign: "middle" }} />
                </Button>
            ),
        },
    ];

    return (
        <PageContainer pageBackground="white" contentPadding={16}>
            <Row justify="space-between" style={{ height: "calc(100vh - var(--header-height))" }}>
                <div style={{ padding: "24px 16px 16px" }}>
                    {info.map((item) => (
                        <div key={item.title} className={styles.card}>
                            <p className={styles.title} style={{ marginBottom: "10px" }}>
                                {item.title}
                            </p>
                            {item.info}
                        </div>
                    ))}
                </div>
                <LayoutFooter />
            </Row>
        </PageContainer>
    );
};

export default WithDrawalInfo;
